import { EoyStatusEnum } from '@lon/shared/requests';

export const colorByStatus: Record<
  EoyStatusEnum,
  { bg: string; color: string }
> = {
  [EoyStatusEnum.Error]: {
    bg: 'red.200',
    color: 'red.800',
  },
  [EoyStatusEnum.Completed]: {
    bg: 'green.light',
    color: 'olive.900',
  },
  [EoyStatusEnum.Confirmed]: {
    bg: 'calendar.blue.100',
    color: 'calendar.blue.800',
  },
  [EoyStatusEnum.InProgress]: {
    bg: 'violet.100',
    color: 'violet.800',
  },
  [EoyStatusEnum.TimeToConfirm]: {
    bg: 'yellow.extraLight',
    color: 'yellow.800',
  },
  [EoyStatusEnum.Scheduled]: {
    bg: 'beige.100',
    color: 'beige.900',
  },
  [EoyStatusEnum.PreliminarySetup]: {
    bg: 'secondary.100',
    color: 'secondary.800',
  },
};
